import React, { useEffect, useState } from "react";
import Appbar from "./Components/appbar";
import Menu from "./Components/Menu";
import Footer from "./Components/Footer";
import "../style/TripBooking.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { faBus } from "@fortawesome/free-solid-svg-icons";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import Modal from "react-modal";
import { faMessage } from "@fortawesome/free-solid-svg-icons/faMessage";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { Link, useLocation } from "react-router-dom";
import Loading from "./Loading";
import SmallLoading from "./SmallLoading";
import StatusTypeModel from "./Components/StatusSubModal";

function formatDateTime(dateString) {
  const date = new Date(dateString);

  // Format the day, month (3-char), and year
  const day = date.getDate().toString().padStart(2, "0"); // Ensure 2 digits for day
  const month = date.toLocaleString("en-US", { month: "short" }); // 'Sep' for September
  const year = date.getFullYear(); // Get the year

  // Format the time as 'h:mm AM/PM'
  const hours = date.getHours() % 12 || 12; // Convert to 12-hour format
  const minutes = date.getMinutes().toString().padStart(2, "0"); // Ensure 2 digits for minutes
  const ampm = date.getHours() >= 12 ? "PM" : "AM"; // Determine AM or PM

  return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
}

const DateTimeConvert = (str) => {
  const date = new Date(str);

  const istOffset = 5.5 * 60;
  const localDate = new Date(date.getTime() + istOffset * 60 * 1000);

  const day = localDate.getUTCDate();
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = monthNames[localDate.getUTCMonth()];
  const year = localDate.getUTCFullYear();

  let hours = localDate.getUTCHours();
  const minutes = localDate.getUTCMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;

  const formattedDate = `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
  return formattedDate;
};

const DateTimeDisplay = (str) => {
  //console.log("Time =====",str)

  const date = new Date(str);

  // Add 5 hours and 30 minutes to convert to IST
  const istDate = new Date(date.getTime() + 5.5 * 60 * 60 * 1000);

  // Convert to ISO string and slice to get the date and time up to minutes
  const formattedDate = istDate.toISOString().slice(0, 16).replace("T", " ");
  //console.log("Formated Date ==",formattedDate)
  return formattedDate;
};

const FormatDate = (inp) => {
  let dateformat = inp.split("T")[0];
  const date = moment(dateformat, "YYYY-MM-DD");
  return date.format("DD-MMM-YYYY");
};

const convert = (str) => {
  var date = new Date(str),
    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
  return [date.getFullYear(), mnth, day].join("-");
};

export default function TripBooking(prop) {
  const location = useLocation();
  const passedState = location.state;

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalIsOpen1, setModalIsOpen1] = useState(false);

  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);

  const openModal1 = () => setModalIsOpen1(true);
  const closeModal1 = () => setModalIsOpen1(false);

  const [BookingList, SetBookingList] = useState([]);
  const [CustomerList, SetCustomerList] = useState([]);
  const [DriverList, SetDriverList] = useState([]);
  const [BusList, SetBusList] = useState([]);
  const [BookingStatus, SetBookingStatus] = useState([]);
  const [BusStatus, SetBusStatus] = useState([]);
  const [PaymentMode, SetPaymentMode] = useState([]);
  const [TripReason, SetTripReason] = useState([]);
  const [selectedBooking, setSelectedBooking] = useState(null);

  const [selectedContact, setSelectedContact] = useState("");

  const [searchQuery, setSearchQuery] = useState("");
  const [isDateInput, setIsDateInput] = useState(false);

  const [isDateTime1, setIsDateTime1] = useState(false);
  const [isDateTime2, setIsDateTime2] = useState(false);

  const [username, setUsername] = useState("");
  const [rights, setRights] = useState("");

  const [pickup, setPickup] = useState("");
  const [drop, setDrop] = useState("");
  const [pickupCityList, setPickupCityList] = useState([]);
  const [dropCityList, setDropCityList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [subModalIsOpen, setSubModalIsOpen] = useState(false);
  const [statusType, setStatusType] = useState(null);
  const [statusTypeSub, setStatusTypeSub] = useState({
    Status: null,
    Status_Ref: null,
  });

  const handleSubModalOpen = () => setSubModalIsOpen(true);
  const handleSubModalClose = () => setSubModalIsOpen(false);

  const handleStatusOnChange = async (e) => {
    let { name, value } = e.target;
    setStatusTypeSub({ ...statusTypeSub, [name]: value.toUpperCase() });
  };

  function selectStatusType(statusType) {
    switch (statusType) {
      case "Booking Status":
        return "Booking_Status";
        break;
      case "Trip Reason":
        return "Trip_Reason";
        break;
      case "Bus Status":
        return "Bus_Status";
        break;
      case "Mode Of Payment":
        return "Mode_of_Payment";
        break;

      default:
        break;
    }
  }

  const handleStatusTypeSubjectSubmit = async (event) => {
    event.preventDefault();
    const status = statusType ? selectStatusType(statusType) : "";
    console.log(status, statusType);
    try {
      await axios
        .post(
          `${process.env.REACT_APP_API_BASE_URL}/statusTypeSub/AddStatusTypeSub/${status}`,
          statusTypeSub,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            SuccessMSG(res.data.message);
            setStatusTypeSub({ Status: null, Status_Ref: null });
            fetchBusList();
            setStatusType(null);
            handleSubModalClose();
          }
          if (res.status === 201) {
            WarningMSG(res.data.message);
          }
        })
        .catch((err) => {
          if (err.response && err.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
      event.target.reset();
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  const handleInputChange = async (e, type) => {
    const query = e.target.value;
    const pattern = /[^a-zA-Z ]/g;
    let result = pattern.test(query);

    if (result) {
      return;
    }

    if (type === "pickup") {
      setPickup(query);
      formData.pickupLocation = query;
    } else {
      setDrop(query);
      formData.dropLocation = query;
    }

    if (query.length > 1) {
      try {
        const response = await axios.get(
          `https://api.opencagedata.com/geocode/v1/json?q=${query}&key=8f189cec7c4c4cf3a8bf827d91681d5c`
        );
        if (type === "pickup") {
          setPickupCityList(response.data.results);
        } else {
          setDropCityList(response.data.results);
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleSelectLocation = (location, type) => {
    if (type === "pickup") {
      setPickup(location);
      selectedBooking
        ? setSelectedBooking({
            ...selectedBooking,
            pickupLocation: location,
          })
        : setFormData({
            ...formData,
            pickupLocation: location,
          });
      setPickupCityList([]); // Clear suggestions once selected
    } else {
      setDrop(location);
      selectedBooking
        ? setSelectedBooking({
            ...selectedBooking,
            dropLocation: location,
          })
        : setFormData({
            ...formData,
            dropLocation: location,
          });
      setDropCityList([]); // Clear suggestions once selected
    }
  };

  const filteredBooking = searchQuery
    ? BookingList.filter((item) =>
        item.Customer_Name.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : BookingList;

  const InitState = {
    customerName: null,
    aadharNumber: null,
    customerContact1: null,
    customerContact2: null,
    wifi: null,
    busStatus: null,
    driverName: null,
    driverContact1: null,
    driverContact2: null,
    modeOfPayment: null,
    departureDateTime: null,
    araivalDateTime: null,
    pickupLocation: null,
    dropLocation: null,
    tripReason: null,
    tripType: "Round Trip",
    busName: null,
    busModelName: null,
    busRegNo: null,
    lastServiceDate: null,
    totalFare: null,
    paid: null,
    balance: null,
    bookingStatus: null,
    user: username,
  };

  const [formData, setFormData] = useState(InitState);

  const fetchBookingList = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/tripBooking/FetchTripBookingList`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );
      //console.log("Fetched data:", response.data);// Log the fetched data
      SetBookingList(response.data);
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };
  const fetchBusList = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/bus/FetchBusList`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );
      const response1 = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/driver/FetchDriverList`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );
      const response2 = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/customer/FetchCustomerList`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );
      const response3 = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/statusTypeSub/FetchStatusTypeSubByStatusName/Bus_Status`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );
      const response4 = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/statusTypeSub/FetchStatusTypeSubByStatusName/Trip_Reason`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );
      const response5 = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/statusTypeSub/FetchStatusTypeSubByStatusName/Booking_Status`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );
      const response6 = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/statusTypeSub/FetchStatusTypeSubByStatusName/Mode_Of_Payment`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );
      SetPaymentMode(response6.data);
      SetBookingStatus(response5.data);
      SetTripReason(response4.data);
      SetBusStatus(response3.data);
      SetCustomerList(response2.data);
      SetDriverList(response1.data);
      SetBusList(response.data);
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  useEffect(() => {
    fetchBookingList();
    fetchBusList();
    setUsername(sessionStorage.getItem("username"));
    setRights(sessionStorage.getItem("rights"));
  }, []);

  const SuccessMSG = (msg) => {
    //console.log(msg)
    toast.success(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };

  const WarningMSG = (msg) => {
    //console.log(msg)
    toast.warning(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };
  const FailedMSG = (msg) => {
    //console.log(msg)
    toast.error(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };
  const handleEdit = (Booking) => {
    const InitStateEdit = {
      BookingId: Booking.Booking_Id,
      customerName: Booking.Customer_Name,
      aadharNumber: Booking.Aadhar_Number,
      customerContact1: Booking.Contact1,
      customerContact2: Booking.Contact2,
      wifi: Booking.Wifi,
      busStatus: Booking.Bus_Status,
      driverName: Booking.Driver_Name,
      driverContact1: Booking.Driver_Contact1,
      driverContact2: Booking.Driver_Contact2,
      modeOfPayment: Booking.Mode_of_Payment,
      departureDateTime:
        Booking.Departure_Datetime == null ? null : Booking.Departure_Datetime,
      araivalDateTime:
        Booking.Araival_Datetime == null ? null : Booking.Araival_Datetime,
      pickupLocation: Booking.Pickup_Location,
      dropLocation: Booking.Drop_Location,
      tripReason: Booking.Trip_Reason,
      tripType: Booking.Trip_Type,
      busName: Booking.Bus_Name,
      busModelName: Booking.Model_Name,
      busRegNo: Booking.Register_Number,
      lastServiceDate:
        Booking.Last_Service_Date == null
          ? null
          : convert(Booking.Last_Service_Date.toString()),
      totalFare: Booking.Fare,
      paid: Booking.Paid,
      balance: Booking.Balance,
      bookingStatus: Booking.Booking_Status,
      user: username,
    };
    setSelectedBooking(InitStateEdit);
    setPickup(Booking.Pickup_Location);
    setDrop(Booking.Drop_Location);
    //console.log(InitStateEdit)
    setModalIsOpen(true);
  };

  const handleModalClose = () => {
    const confirmClose = window.confirm("Are you sure you want to close?");
    if (confirmClose) {
      setModalIsOpen(false);
      setFormData(InitState);
      setSelectedBooking(null);
      setPickup("");
      setDrop("");
      setPickupCityList([]);
      setDropCityList([]);
    }
  };

  const handleCustomerSelectChange = (e) => {
    const selectedIndex = CustomerList.findIndex(
      (item) => item.Customer_Name === e
    );
    const CustomerName = CustomerList[selectedIndex].Customer_Name;
    const AadharNumber =
      CustomerList[selectedIndex].Aadhar_Number != null
        ? CustomerList[selectedIndex].Aadhar_Number
        : "";
    const contact1 = CustomerList[selectedIndex].Contact1;
    const contact2 =
      CustomerList[selectedIndex].Contact2 != null
        ? CustomerList[selectedIndex].Contact2
        : "";
    setFormData({
      ...formData,
      customerName: CustomerName,
      customerContact1: contact1,
      aadharNumber: AadharNumber,
      customerContact2: contact2,
    });
  };

  const handleDriverSelectChange = (e) => {
    const selectedIndex = DriverList.findIndex(
      (item) => item.Driver_Name === e
    );
    const DriverId = DriverList[selectedIndex].Driver_Id;
    const DriverName = DriverList[selectedIndex].Driver_Name;
    const contact1 = DriverList[selectedIndex].Contact_Number1;
    const contact2 =
      DriverList[selectedIndex].Contact_Number2 != null
        ? DriverList[selectedIndex].Contact_Number2
        : "";
    setFormData({
      ...formData,
      driverId:DriverId,
      driverName: DriverName,
      driverContact1: contact1,
      driverContact2: contact2,
    });
  };

  const handleBusSelectChange = (e) => {
    //console.error(e);
    const selectedIndex = BusList.findIndex((item) => item.Bus_Name === e);
    const BusName = BusList[selectedIndex].Bus_Name;
    const BusModelName = BusList[selectedIndex].Model_Name;
    const BusStatus = BusList[selectedIndex].Bus_Status;
    const BusId = BusList[selectedIndex].Bus_Id;
    const Wifi =
      BusList[selectedIndex].Wifi != null ? BusList[selectedIndex].Wifi : "";
    const LastService = BusList[selectedIndex].Last_Service_Date;
    const BusRegNo = BusList[selectedIndex].Register_Number;
    setFormData({
      ...formData,
      busId:BusId,
      busName: BusName,
      busRegNo: BusRegNo,
      busModelName: BusModelName,
      busStatus: BusStatus,
      wifi: Wifi,
      lastServiceDate:
        LastService == null ? null : convert(LastService.toString()),
    });
  };

  const updateCustomerSelectChange = (e) => {
    const selectedIndex = CustomerList.findIndex(
      (item) => item.Customer_Name === e
    );
    const CustomerName = CustomerList[selectedIndex].Customer_Name;
    const AadharNumber =
      CustomerList[selectedIndex].Aadhar_Number != null
        ? CustomerList[selectedIndex].Aadhar_Number
        : "";
    const contact1 = CustomerList[selectedIndex].Contact1;
    const contact2 =
      CustomerList[selectedIndex].Contact2 != null
        ? CustomerList[selectedIndex].Contact2
        : "";
    setSelectedBooking({
      ...selectedBooking,
      customerName: CustomerName,
      customerContact1: contact1,
      aadharNumber: AadharNumber,
      customerContact2: contact2,
    });
  };

  const updateDriverSelectChange = (e) => {
    const selectedIndex = DriverList.findIndex(
      (item) => item.Driver_Name === e
    );
    const DriverId= DriverList[selectedIndex].Driver_Id;
    const DriverName = DriverList[selectedIndex].Driver_Name;
    const contact1 = DriverList[selectedIndex].Contact_Number1;
    const contact2 =
      DriverList[selectedIndex].Contact_Number2 != null
        ? DriverList[selectedIndex].Contact_Number2
        : "";
    setSelectedBooking({
      ...selectedBooking,
      driverId:DriverId,
      driverName: DriverName,
      driverContact1: contact1,
      driverContact2: contact2,
    });
  };

  const updateBusSelectChange = (e) => {
    //console.error(e);
    const selectedIndex = BusList.findIndex((item) => item.Bus_Name === e);
    const BusId = BusList[selectedIndex].Bus_Id;
    const BusName = BusList[selectedIndex].Bus_Name;
    const BusModelName = BusList[selectedIndex].Model_Name;
    const BusStatus = BusList[selectedIndex].Bus_Status;
    const Wifi =
      BusList[selectedIndex].Wifi != null ? BusList[selectedIndex].Wifi : "";
    const LastService = BusList[selectedIndex].Last_Service_Date;
    const BusRegNo = BusList[selectedIndex].Register_Number;
    setSelectedBooking({
      ...selectedBooking,
      busId:BusId,
      busName: BusName,
      busRegNo: BusRegNo,
      busModelName: BusModelName,
      busStatus: BusStatus,
      wifi: Wifi,
      lastServiceDate:
        LastService == null ? null : convert(LastService.toString()),
    });
  };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   // //console.log(name,value)
  //   const pattern = /[^A-Za-z ]/g;

  //   if ((name === "pickupLocation" || name === "dropLocation")){
  //     if (name === "pickupLocation") {
  //       setSelectedBooking({
  //         ...selectedBooking,
  //         [name]: value,
  //       });
  //       setPickup(value);
  //       handleInputChange(e, "pickup");
  //     } else {
  //       setSelectedBooking({
  //         ...selectedBooking,
  //         [name]: value,
  //       });
  //       setDrop(value);
  //       handleInputChange(e, "drop");
  //     }
  //   } else if (
  //     name === "customerContact2" ||
  //     "driverContact2" ||
  //     "totalFare" ||
  //     "paid"
  //   ) {
  //     if (name === "tripReason") {
  //       //console.log(name,value)
  //       setFormData({
  //         ...formData,
  //         [name]: value,
  //       });
  //       //console.log(formData)
  //     }
  //     if (value > 9999999999) {
  //       setFormData({
  //         ...formData,
  //         [name]: value.replace(/[^0-9]/g, "").slice(0, 10),
  //       });
  //     } else {
  //       setFormData({
  //         ...formData,
  //         [name]: value.replace(/[^0-9]/g, ""),
  //       });
  //     }
  //   } else {
  //     setFormData({
  //       ...formData,
  //       [name]: value,
  //     });
  //   }
  // };


  const handleChange = (e) => {
    const { name, value } = e.target;
   // //console.log(name,value)
    const pattern = /[^a-zA-Z ]/g;
    if(name === "pickupLocation" || name ==="dropLocation"){
      let result = pattern.test(value);
      if(result){
        setFormData({
          ...formData,
          [name]: value.replace(pattern,'')
        });
        
      }else{
        setFormData({
          ...formData,
          [name]: value
        });
      }
    }
    else if(name === "customerContact2" || "driverContact2" || "totalFare" || "paid"){
        if(name === "tripReason"){
        //console.log(name,value)
        setFormData({
          ...formData,
          [name]: value
        });
        //console.log(formData)
        }
      if(value > 9999999999){
        setFormData({
          ...formData,
          [name]: value.replace(/[^0-9]/g, '').slice(0,10)
        });
      }else{
        setFormData({
          ...formData,
          [name]: value.replace(/[^0-9]/g, '')
        });
      }
    }
    else{
    setFormData({
      ...formData,
      [name]: value
    });
  }
  }

  const handleContactChange = (e) => {
    setSelectedContact(e.target.value);
  };

  const handleClick = () => {
    setIsDateTime1(!isDateTime1);
  };
  const handleClick1 =  () => {
    setIsDateTime1(!isDateTime1);
  };
  const handleClick01 = () => {
    setIsDateTime2(!isDateTime2);
  };
  const handleClick02 = async() => {
    setIsDateTime2(!isDateTime2);
  };

  // const checkBusAndDriverAndTimeAvailabilty=async(user_time,busId,driverId)=>{
  //   try {
  //     const timeAvailability=await axios
  //       .get(
  //         `${process.env.REACT_APP_API_BASE_URL}/tripBooking/checkTripBookingExists/${user_time}/${busId}/${driverId}`
  //       )
  //       setIsLoading(false);
  //       return timeAvailability.data.success ? true : false
  //   } catch (error) {
  //     if (error.response.status!==200)
  //       setFormData({...formData,departureDateTime:null})
  //       FailedMSG(error.response.data.data);
  //       setIsLoading(false);
  //       return false
  //   }
  // }

  // const checkTripBookingExistsByBookingId=async(user_time,busName,driverName,bookingId)=>{
  //   console.log(user_time,busName,driverName,bookingId)
  //   try {
  //     const timeAvailability=await axios
  //       .get(
  //         `${process.env.REACT_APP_API_BASE_URL}/tripBooking/checkTripBookingExistsByBookingId/${user_time}/${busName}/${driverName}/${bookingId}`
  //       )
  //       setIsLoading(false);
  //       return timeAvailability.data.success ? true : false
  //   } catch (error) {
  //     if (error.response.status!==200)
  //       setFormData({...formData,departureDateTime:null})
  //       FailedMSG(error.response.data.data);
  //       setIsLoading(false);
  //       return false
  //   }
  // }

  const handleChangeDate = (e) => {
    const { name, value } = e.target;
    //console.log("brvvuhfv",value)
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleUpdateDate = (e) => {
    const { name, value } = e.target;
    //console.log("brvvuhfv",value)
    setSelectedBooking({
      ...selectedBooking,
      [name]: value,
    });
  };

  const handleUpdate = (e) => {
    const { name, value } = e.target;
    const pattern = /[^a-zA-Z ]/g;
    let result = pattern.test(value);
    console.log(result, value);

    if (result && isNaN(value)) {
      return;
    }

    if (name === "pickupLocation" || name === "dropLocation") {
      console.log("its string");

      if (name === "pickupLocation") {
        setSelectedBooking({
          ...selectedBooking,
          [name]: value,
        });
        setPickup(value);
        handleInputChange(e, "pickup");
      } else {
        setSelectedBooking({
          ...selectedBooking,
          [name]: value,
        });
        setDrop(value);
        handleInputChange(e, "drop");
      }
    } else if (
      name === "customerContact2" ||
      "driverContact2" ||
      "totalFare" ||
      "paid"
    ) {
      if (value > 9999999999) {
        setSelectedBooking({
          ...selectedBooking,
          [name]: value.replace(/[^0-9]/g, "").slice(0, 10),
        });
      } else {
        setSelectedBooking({
          ...selectedBooking,
          [name]: value.replace(/[^0-9]/g, ""),
        });
      }
    } else {
      setSelectedBooking({
        ...selectedBooking,
        [name]: value,
      });
    }
    //console.log('Selected Booking:', selectedBooking);
    //console.log('Form Data:', formData);
  };
  const handleChangeStatus = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleUpdateStatus = (e) => {
    setSelectedBooking({
      ...selectedBooking,
      [e.target.name]: e.target.value,
    });
  };

  const UpdateForm = async (event) => {
    event.preventDefault();
    if (
      selectedBooking.pickupLocation.toUpperCase() ===
      selectedBooking.dropLocation.toUpperCase()
    ) {
      WarningMSG("Check Pick and Drop Location");
    } else {
      try {
        //console.log(selectedBooking)

        setIsLoading(true);
        console.log(selectedBooking)
        await axios
          .put(
            `${process.env.REACT_APP_API_BASE_URL}/tripBooking/UpdateTripBooking/${selectedBooking.BookingId}`,
            selectedBooking,
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem(
                  "access_token"
                )}`,
              },
            }
          )
          .then((res) => {
            SuccessMSG(res.data.message);
            setSelectedBooking([]);
            setPickup("");
            setDrop("");
            fetchBookingList();
            setIsLoading(false);
          })
          .catch((error) => {
            console.log(error.response)
            if (error.response && error.response.status !== 200)
              FailedMSG(error.response.data.message);
          });
      } catch (error) {
        if (error.response && error.response.status !== 200)
          FailedMSG("Something went Wrong");
      }
      finally{
        setSelectedBooking([]);
        setPickup("");
        setDrop("");
        fetchBookingList();
        setIsLoading(false);
        closeModal();
      }
      
    }
  };

  const handleDelete = (Booking) => {
    try {
      const confirm = window.confirm("Are you sure you want to delete this?");
      if (!confirm) return;
      axios
        .delete(
          `${process.env.REACT_APP_API_BASE_URL}/tripBooking/DeleteTripBooking/${Booking.Booking_Id}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        )
        .then((res) => {
          SuccessMSG(res.data.message);
          fetchBookingList();
        })
        .catch((error) => {
          if (error.response && error.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  const handleSendMessage = async () => {
    if (
      formData.customerName === null ||
      formData.busName === null ||
      formData.driverName === null ||
      formData.pickupLocation === null ||
      formData.departureDateTime === null
    ) {
      WarningMSG("Please fill the form");
    } else {
      try {
        await axios
          .post(
            `${process.env.REACT_APP_API_BASE_URL}/whatsapp/SendMessage`,
            formData,
            {}
          )
          .then((res) => {
            if (res.status === 200) {
              SuccessMSG("Message Sent Successfully");
            }
            if (res.status === 401) {
              FailedMSG("Message Sent Failed");
            }
          })
          .catch((error) => {
            if (error.response && error.response.status !== 200)
              FailedMSG("Something went Wrong");
          });
      } catch (error) {
        if (error.response && error.response.status !== 200)
          FailedMSG("Something went Wrong");
      }
    }
  };

  const handleUpdateSendMessage = async () => {
    if (
      selectedBooking.customerName === null ||
      selectedBooking.busName === null ||
      selectedBooking.driverName === null ||
      selectedBooking.pickupLocation === null ||
      selectedBooking.departureDateTime === null
    ) {
      WarningMSG("Please fill the form");
    } else {
      try {
        axios
          .post(
            `${process.env.REACT_APP_API_BASE_URL}/whatsapp/SendMessage`,
            selectedBooking,
            {}
          )
          .then((res) => {
            if (res.status === 200) {
              SuccessMSG("Message Sent Successfully");
            }
            if (res.status === 500) {
              FailedMSG("Message Sent Failed");
            }
          })
          .catch((error) => {
            if (error.response && error.response.status !== 200)
              FailedMSG("Something went Wrong");
          });
      } catch (error) {
        if (error.response && error.response.status !== 200)
          FailedMSG("Something went Wrong");
      }
    }
  };

  // const handleSubmit = async (event) => {
  //   event.preventDefault();
  //   formData["user"] = username;
  //   if (
  //     formData.pickupLocation.toUpperCase() ===
  //     formData.dropLocation.toUpperCase()
  //   ) {
  //     WarningMSG("Check Pick and Drop Location");
  //   } else {
  //     try {
  //       console.log(formData);
  //       setIsLoading(true);
  //       await Promise (checkBusAndDriverAndTimeAvailabilty())
  //       await axios
  //         .post(
  //           `${process.env.REACT_APP_API_BASE_URL}/tripBooking/AddTripBooking`,
  //           formData,
  //           {
  //             headers: {
  //               Authorization: `Bearer ${sessionStorage.getItem(
  //                 "access_token"
  //               )}`,
  //             },
  //           }
  //         )
  //         .then((res) => {
  //           if (res.status === 200) {
  //             SuccessMSG(res.data.message);
  //             setIsLoading(false);
  //             fetchBookingList();
  //           }
  //           if (res.status === 201) {
  //             FailedMSG(res.data.message);
  //             setIsLoading(false);
  //             fetchBookingList();
  //           }
  //           setFormData([]);
  //           fetchBookingList();
  //         })
  //         .catch((error) => {
  //           if (error.response && error.response.status !== 200)
  //             setIsLoading(false);
  //           FailedMSG("Something went Wrong");
  //         });
  //     } catch (error) {
  //       if (error.response && error.response.status !== 200)
  //         FailedMSG("Something went Wrong");
  //     }
  //     //console.log(formData);
  //     setFormData(InitState);
  //     closeModal();
  //   }
  // };


  const handleSubmit = async (event) => {
    event.preventDefault();
  
    // Add username to formData
    formData["user"] = username;
  
    // Validate pickup and drop locations
    if (formData.pickupLocation.toUpperCase() === formData.dropLocation.toUpperCase()) {
      WarningMSG("Pickup and Drop Location cannot be the same.");
      return;
    }
  
    try {
      // Start loading state
      setIsLoading(true);
  
      // Check bus, driver, and time availability
      // const isAvailable = await checkBusAndDriverAndTimeAvailabilty(formData.departureDateTime,formData.busId,formData.driverId);

      // if (!isAvailable) {
      //   console.log("Time Invalid")
      //   FailedMSG("Bus, driver, or time is not available.");
      //   setIsLoading(false);
      //   return;
      // }
  
      // Make the API call to add the trip booking
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/tripBooking/AddTripBooking`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        }
      );
  
      // Handle successful response
      if (response.status === 200) {
        setFormData({
          ...formData,
          dropLocation:null,
          pickupLocation:null
        })
        SuccessMSG(response.data.message);
      } else if (response.status === 201) {
        setFormData({
          ...formData,
          dropLocation:null,
          pickupLocation:null
        })
        FailedMSG(response.data.message);
      }
  
      // Fetch updated booking list
      fetchBookingList();
    } catch (error) {
      // Handle errors
      console.error("Error during trip booking:", error);
  
      if (error.response) {
        FailedMSG(error.response.data?.message || "An error occurred while booking the trip.");
      } else if (error.request) {
        FailedMSG("Unable to connect to the server. Please check your internet connection.");
      } else {
        FailedMSG("An unexpected error occurred.");
      }
    } finally {
      // Stop loading state and reset form data
      setFormData({
        ...formData,
        dropLocation:null,
        pickupLocation:null
      })
      setIsLoading(false);
      setFormData(InitState); // Reset to initial state
      closeModal(); // Close the modal
    }
  };

  const today = new Date().toISOString().split("T")[0];
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const minDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;
  const todayDate = new Date().toISOString().slice(0, 16); // Format as 'YYYY-MM-DDTHH:MM'

  return (
    <>
      <ToastContainer />
      <Appbar username={username} rights={rights}></Appbar>

      {!isLoading && (
        <div className="TripBooking">
          <Menu username={username} rights={rights}></Menu>
          <div className="TripBookingPage">
            <p className="TripBookingLabel">Trip Booking</p>
            <div className="TripBookingHeader">
              <div className="TripBookingSearch">
                <input
                  className="TripBookingInput"
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Customer Name"
                ></input>
                <button className="TripBookingSearchBtn">
                  <FontAwesomeIcon
                    className="TripBookingSearchIcon"
                    title="Search"
                    icon={faSearch}
                  ></FontAwesomeIcon>
                </button>
              </div>
              <button
                className="NewTripBookingBtn"
                title="New Booking"
                onClick={openModal}
              >
                New Booking{" "}
                <FontAwesomeIcon
                  className="NewTripBookingIcon"
                  icon={faPlus}
                ></FontAwesomeIcon>
              </button>
            </div>
            <Modal
              isOpen={modalIsOpen}
              onRequestClose={handleModalClose}
              shouldCloseOnOverlayClick={false}
              contentLabel="Booking Form"
              center
              style={{
                overlay: {
                  background: "rgba(0,0,0,0.6)",
                  position: "fixed",
                  top: "0",
                  left: "0",
                  right: "0",
                  bottom: "0",
                },
                content: {
                  background:
                    "linear-gradient(168deg, #c1e0ff 0%, #efdeff 100%)",
                  position: "absolute",
                  top: "40px",
                  left: "25%",
                  right: "25%",
                  bottom: "40px",
                  height: "auto",
                  width: "50%",
                  overflow: "scroll",
                },
              }}
            >
              <FontAwesomeIcon
                className="TripBookingFormCloseBtn"
                onClick={handleModalClose}
                title="Close"
                icon={faClose}
              ></FontAwesomeIcon>
              <p className="TripBookingFormHeadLabel">
                {selectedBooking?.BookingId
                  ? "Edit Trip Booking"
                  : "Trip Booking"}
              </p>
              <form
                className="TripBookingForm"
                onSubmit={
                  selectedBooking?.BookingId ? UpdateForm : handleSubmit
                }
              >
                <div className="TripBookingFormFlex">
                  <p className="TripBookingFormHeadLables">Customer Details</p>
                  <div className="TripBookingform0">
                    <div className="TripBookingformCustomerDetails0">
                      <label className="TripBookingFormLabels">
                        Customer Name <span>*</span>{" "}
                      </label>
                      <div className="TripBookingCustomerBox">
                        <select
                          className="TripBookingFormCustomerSelects"
                          name="customerName"
                          value={
                            selectedBooking
                              ? selectedBooking.customerName
                              : formData.customerName
                          }
                          onChange={
                            selectedBooking
                              ? (e) =>
                                  updateCustomerSelectChange(e.target.value)
                              : (e) =>
                                  handleCustomerSelectChange(e.target.value)
                          }
                        >
                          <option>
                            {selectedBooking
                              ? selectedBooking.customerName
                              : "Select"}
                          </option>
                          {CustomerList.map((item, index) => (
                            <option key={index} value={item.Customer_Name}>
                              {item.Customer_Name}
                            </option>
                          ))}
                        </select>
                        <Link
                          state={{ username: username, rights: rights }}
                          to={"/Customer"}
                        >
                          <FontAwesomeIcon
                            className="TripBookingAddCustomerIcon"
                            title="Add Customer"
                            icon={faPlus}
                          ></FontAwesomeIcon>
                        </Link>
                      </div>
                      <label className="TripBookingFormLabels">
                        Aadhar Number
                      </label>
                      <input
                        disabled
                        placeholder="Aadhar Number"
                        className="TripBookingFormInputs"
                        type="number"
                        name="aadharNumber"
                        value={
                          selectedBooking
                            ? selectedBooking.aadharNumber
                            : formData.aadharNumber
                        }
                      ></input>
                      <label className="TripBookingFormLabels">
                        Customer Contact 1 <span>*</span>
                      </label>
                      <input
                        disabled
                        placeholder="xxxxxxxxxx"
                        className="TripBookingFormInputs"
                        type="number"
                        name="customerContact1"
                        value={
                          selectedBooking?.customerContact1 ||
                          formData.customerContact1
                        }
                      ></input>
                      <label className="TripBookingFormLabels">
                        Customer Contact 2
                      </label>
                      <input
                        disabled
                        placeholder="xxxxxxxxxx"
                        className="TripBookingFormInputs"
                        type="text"
                        name="customerContact2"
                        value={
                          selectedBooking
                            ? selectedBooking.customerContact2
                            : formData.customerContact2
                        }
                        onChange={selectedBooking ? handleUpdate : handleChange}
                      ></input>
                      <label className="TripBookingFormLabels">
                        Departure Date - Time <span>*</span>
                      </label>

                      <input
                        required
                        placeholder="01-Jan-1900"
                        type={isDateTime2 ? "datetime-local" : "text"}
                        onFocus={handleClick01}
                        onBlur={handleClick02}
                        readOnly={!isDateTime2}
                        className="TripBookingFormInputs"
                        name="departureDateTime"
                        value={
                          selectedBooking
                            ? selectedBooking.departureDateTime
                              ? formatDateTime(
                                  selectedBooking.departureDateTime
                                )
                              : selectedBooking.departureDateTime
                            : formData.departureDateTime
                            ? formatDateTime(
                                formData.departureDateTime.toString()
                              )
                            : formData.departureDateTime
                        }
                        onChange={(e) =>
                          selectedBooking
                            ? handleUpdateDate(e)
                            : handleChangeDate(e)
                        }
                        min={todayDate} // Ensures past dates/times cannot be selected
                      />
                    </div>
                    <div className="TripBookingformCustomerDetails1">
                      <div className="TripBookingformCustomerDetailsIndex0"></div>
                      <div className="TripBookingformCustomerDetailsIndex1">
                      <label className='TripBookingFormLabels'>Pickup Location <span>*</span></label><input placeholder='Location' className="TripBookingFormInputs" type="text" required name="pickupLocation" value={selectedBooking?.pickupLocation || formData.pickupLocation} onChange={selectedBooking? handleUpdate : handleChange } ></input>
                      <label className='TripBookingFormLabels'>Drop Location <span>*</span></label><input placeholder='Location' className="TripBookingFormInputs" type="text" required name="dropLocation" value={selectedBooking?.dropLocation || formData.dropLocation} onChange={selectedBooking? handleUpdate : handleChange }></input>
                        <label className="TripBookingFormLabels">
                          Trip Reason <span>* </span>{" "}
                          <Link
                            style={{ fontSize: "12px" }}
                            state={{ username: username, rights: rights }}
                            to={""}
                            onClick={() => {
                              setStatusType("Trip Reason");
                              handleSubModalOpen();
                            }}
                          >
                            {" "}
                            (Add Trip Reason)
                          </Link>
                        </label>
                        <select
                          className="TripBookingFormSelects"
                          name="tripReason"
                          required
                          value={
                            selectedBooking?.tripReason || formData.tripReason
                          }
                          onChange={
                            selectedBooking
                              ? handleUpdateStatus
                              : handleChangeStatus
                          }
                        >
                          <option value={""}> Select </option>
                          {TripReason.map((item, index) => (
                            <option key={index} value={item.Status_Ref}>
                              {item.Status_Ref}
                            </option>
                          ))}
                        </select>
                        <label
                          style={{ marginTop: "15px" }}
                          className="TripBookingFormLabels"
                        >
                          Trip Type <span>* </span>{" "}
                        </label>
                        <select
                          className="TripBookingFormSelects"
                          name="tripType"
                          required
                          value={selectedBooking?.tripType || formData.tripType}
                          onChange={
                            selectedBooking
                              ? handleUpdateStatus
                              : handleChangeStatus
                          }
                        >
                          <option>Round Trip</option>
                          <option>One-Way Trip</option>
                        </select>
                        <label className="TripBookingFormLabels">
                          Arrival Date - Time <span>*</span>
                        </label>

                        <input
                          required
                          placeholder="01-Jan-1900"
                          type={isDateTime1 ? "datetime-local" : "text"}
                          onFocus={handleClick}
                          onBlur={handleClick1}
                          readOnly={!isDateTime1}
                          className="TripBookingFormInputs"
                          name="araivalDateTime"
                          value={
                            selectedBooking
                              ? selectedBooking.araivalDateTime
                                ? formatDateTime(
                                    selectedBooking.araivalDateTime
                                  )
                                : selectedBooking.araivalDateTime
                              : formData.araivalDateTime
                              ? formatDateTime(
                                  formData.araivalDateTime.toString()
                                )
                              : formData.araivalDateTime
                          }
                          onChange={(e) =>
                            selectedBooking
                              ? handleUpdateDate(e)
                              : handleChangeDate(e)
                          }
                          min={
                              selectedBooking?.departureDateTime?selectedBooking.departureDateTime:formData.departureDateTime ? formData.departureDateTime: todayDate}
                        ></input>
                      </div>
                    </div>
                  </div>
                  <p className="TripBookingFormHeadLables">Bus Details</p>
                  <div className="TripBookingform1">
                    <div className="TripBookingformBusDetails0">
                      <label className="TripBookingFormLabels">
                        Bus Name <span>*</span>
                      </label>
                      <select
                        className="TripBookingFormSelects"
                        value={
                          selectedBooking
                            ? selectedBooking.busName
                            : formData.busName
                        }
                        name="busName"
                        onChange={
                          selectedBooking
                            ? (e) => updateBusSelectChange(e.target.value)
                            : (e) => handleBusSelectChange(e.target.value)
                        }
                      >
                        <option>
                          {selectedBooking ? selectedBooking.busName : "Select"}
                        </option>
                        {BusList.map((item, index) => (
                          <option key={index} value={item.Bus_Name}>
                            {item.Bus_Name}
                          </option>
                        ))}
                      </select>
                      <label className="TripBookingFormLabels">
                        Bus Model Name <span>*</span>{" "}
                      </label>
                      <input
                        disabled
                        placeholder="Bus Model"
                        className="TripBookingFormInputs"
                        type="text"
                        name="busModelName"
                        value={
                          selectedBooking?.busModelName || formData.busModelName
                        }
                      ></input>
                      <label className="TripBookingFormLabels">
                        Bus Register No <span>*</span>
                      </label>
                      <input
                        disabled
                        placeholder="Register Number"
                        className="TripBookingFormInputs"
                        type="text"
                        name="busRegNo"
                        value={selectedBooking?.busRegNo || formData.busRegNo}
                      ></input>
                    </div>
                    <div className="TripBookingformBusDetails1">
                      <label className="TripBookingFormLabels">
                        Last Service Date{" "}
                      </label>
                      <input
                        style={{ height: "35px" }}
                        className="TripBookingFormInputs"
                        type="text"
                        placeholder="01-Jan-1900"
                        disabled={true}
                        name="lastServiceDate"
                        value={
                          selectedBooking
                            ? selectedBooking.lastServiceDate
                              ? FormatDate(selectedBooking.lastServiceDate)
                              : selectedBooking.lastServiceDate
                            : formData.lastServiceDate
                            ? FormatDate(formData.lastServiceDate)
                            : formData.lastServiceDate
                        }
                      ></input>
                      <label className="TripBookingFormLabels">Wifi</label>
                      <select
                        className="TripBookingFormSelects"
                        value={selectedBooking?.wifi || formData.wifi}
                        name="wifi"
                        onChange={selectedBooking ? handleUpdate : handleChange}
                      >
                        <option value={"No"}>No</option>
                        <option value={"Yes"}>Yes</option>
                      </select>

                      <label className="TripBookingFormLabels">
                        Bus Status <span>* </span>{" "}
                        <Link
                          style={{ fontSize: "12px" }}
                          state={{ username: username, rights: rights }}
                          to={""}
                          onClick={() => {
                            setStatusType("Bus Status");
                            handleSubModalOpen();
                          }}
                        >
                          {" "}
                          (Add Status)
                        </Link>
                      </label>
                      <select
                        className="TripBookingFormSelects"
                        name="busStatus"
                        required
                        value={selectedBooking?.busStatus || formData.busStatus}
                        onChange={
                          selectedBooking
                            ? handleUpdateStatus
                            : handleChangeStatus
                        }
                      >
                        <option value={""}>Select</option>
                        {BusStatus.map((item, index) => (
                          <option key={index} value={item.Status_Ref}>
                            {item.Status_Ref}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <p className="TripBookingFormHeadLables">Driver Details</p>
                  <div className="TripBookingform3">
                    <div className="TripBookingformDriverDetails0">
                      <div className="TripBookingformDriverDetailsFeilds">
                        <label className="TripBookingFormLabels">
                          Driver Name <span>*</span>
                        </label>
                        <select
                          className="TripBookingFormSelects"
                          required
                          name="driverName"
                          value={
                            selectedBooking
                              ? selectedBooking.driverName
                              : formData.driverName
                          }
                          onChange={
                            selectedBooking
                              ? (e) => updateDriverSelectChange(e.target.value)
                              : (e) => handleDriverSelectChange(e.target.value)
                          }
                        >
                          <option>
                            {selectedBooking
                              ? selectedBooking.driverName
                              : "Select"}
                          </option>
                          {DriverList.map((item, index) => (
                            <option key={index} value={item.Driver_Name}>
                              {item.Driver_Name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="TripBookingformDriverDetailsFeilds">
                        <label className="TripBookingFormLabels">
                          Driver Contact 1 <span>*</span>
                        </label>
                        <input
                          disabled
                          placeholder="xxxxxxxxxx"
                          className="TripBookingFormInputs"
                          type="number"
                          name="driverContact1"
                          value={
                            selectedBooking?.driverContact1 ||
                            formData.driverContact1
                          }
                        ></input>
                      </div>
                      <div className="TripBookingformDriverDetailsFeilds">
                        <label className="TripBookingFormLabels">
                          Driver Contact 2{" "}
                        </label>
                        <input
                          disabled
                          placeholder="xxxxxxxxxx"
                          className="TripBookingFormInputs"
                          type="text"
                          name="driverContact2"
                          value={
                            selectedBooking
                              ? selectedBooking.driverContact2
                              : formData.driverContact2
                          }
                          onChange={
                            selectedBooking ? handleUpdate : handleChange
                          }
                        ></input>
                      </div>
                    </div>
                  </div>
                  <p className="TripBookingFormHeadLables">Payment Details</p>
                  <div className="TripBookingform2">
                    <div className="TripBookingformPaymentDetails0">
                      <label className="TripBookingFormLabels">
                        Total Fare (₹)
                      </label>
                      <input
                        placeholder="₹ Total Fare"
                        className="TripBookingFormInputs"
                        type="text"
                        name="totalFare"
                        value={selectedBooking?.totalFare || formData.totalFare}
                        onChange={selectedBooking ? handleUpdate : handleChange}
                      ></input>
                      <label className="TripBookingFormLabels">Paid (₹) </label>
                      <input
                        placeholder="₹ Paid"
                        className="TripBookingFormInputs"
                        type="text"
                        name="paid"
                        value={selectedBooking?.paid || formData.paid}
                        onChange={selectedBooking ? handleUpdate : handleChange}
                      ></input>
                      <label className="TripBookingFormLabels">
                        Mode of Payment{" "}
                        <Link
                          style={{ fontSize: "12px" }}
                          state={{ username: username, rights: rights }}
                          to={""}
                          onClick={() => {
                            setStatusType("Mode Of Payment");
                            handleSubModalOpen();
                          }}
                        >
                          {" "}
                          (Add Payment Mode)
                        </Link>{" "}
                      </label>
                      <select
                        className="TripBookingFormSelects"
                        name="modeOfPayment"
                        value={
                          selectedBooking?.modeOfPayment ||
                          formData.modeOfPayment
                        }
                        onChange={
                          selectedBooking
                            ? handleUpdateStatus
                            : handleChangeStatus
                        }
                      >
                        <option value={""}>Select</option>
                        {PaymentMode.map((item, index) => (
                          <option key={index} value={item.Status_Ref}>
                            {item.Status_Ref}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="TripBookingformPaymentDetails1">
                      <label
                        style={{ visibility: "hidden" }}
                        className="TripBookingFormLabels"
                      >
                        Balance
                      </label>
                      <input
                        style={{ visibility: "hidden" }}
                        placeholder="Balance"
                        className="TripBookingFormInputs"
                        type="number"
                        name="balance1"
                      ></input>
                      <label className="TripBookingFormLabels">
                        Balance (₹)
                      </label>
                      <input
                        placeholder="₹ Balance"
                        className="TripBookingFormInputs"
                        type="number"
                        name="balance"
                        value={
                          selectedBooking
                            ? (selectedBooking.balance =
                                selectedBooking.totalFare -
                                selectedBooking.paid)
                            : (formData.balance =
                                formData.totalFare - formData.paid)
                        }
                        onChange={selectedBooking ? handleUpdate : handleChange}
                      ></input>
                      <label className="TripBookingFormLabels">
                        Booking Status <span>*</span>{" "}
                        <Link
                          style={{ fontSize: "12px" }}
                          state={{ username: username, rights: rights }}
                          to={""}
                          onClick={() => {
                            setStatusType("Booking Status");
                            handleSubModalOpen();
                          }}
                        >
                          {" "}
                          (Add Status)
                        </Link>{" "}
                      </label>
                      <select
                        className="TripBookingFormSelects"
                        required
                        name="bookingStatus"
                        value={
                          selectedBooking?.bookingStatus ||
                          formData.bookingStatus
                        }
                        onChange={
                          selectedBooking
                            ? handleUpdateStatus
                            : handleChangeStatus
                        }
                      >
                        <option value={""}>Select</option>
                        {BookingStatus.map((item, index) => (
                          <option key={index} value={item.Status_Ref}>
                            {item.Status_Ref}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="TripBookingFormFooter">
                  <div className="TripBookingFormFooterBtns">
                    <button
                      className="TripBookingformCustomerDetailsSMSBtn"
                      onClick={() =>
                        selectedBooking
                          ? handleUpdateSendMessage()
                          : handleSendMessage()
                      }
                      type="button"
                    >
                      Send <FontAwesomeIcon icon={faMessage}></FontAwesomeIcon>
                    </button>
                    <button
                      className="TripBookingFormSubmitBtn"
                      title="Submit"
                      type="submit"
                    >
                      Confirm
                    </button>
                  </div>
                </div>
              </form>
            </Modal>

            <Modal
              isOpen={modalIsOpen1}
              onRequestClose={closeModal1}
              shouldCloseOnOverlayClick={false}
              contentLabel="Contact"
              style={{
                content: {
                  top: "50%",
                  left: "50%",
                  right: "auto",
                  bottom: "auto",
                  marginRight: "-50%",
                  transform: "translate(-50%, -50%)",
                  padding: "20px",
                },
              }}
            >
              <form
                onSubmit={() =>
                  selectedBooking
                    ? handleUpdateSendMessage()
                    : handleSendMessage()
                }
              >
                <div className="form-group">
                  <label>Select a Contact Number</label>
                  <div>
                    <label>
                      <input
                        disabled
                        type="radio"
                        name="contact"
                        placeholder="xxxxxxxxxx"
                        value={
                          selectedBooking?.customerContact1 ||
                          formData.customerContact1
                        }
                        checked={
                          selectedContact ===
                            selectedBooking?.customerContact1 ||
                          formData.customerContact1
                        }
                        onChange={handleContactChange}
                        required
                      />
                      {selectedBooking?.customerContact1 ||
                        formData.customerContact1}{" "}
                    </label>
                  </div>
                  <div>
                    <label>
                      <input
                        type="radio"
                        name="contact"
                        placeholder="xxxxxxxxxx"
                        value={
                          selectedBooking?.customerContact2 ||
                          formData.customerContact2
                        }
                        checked={
                          selectedContact ===
                            selectedBooking?.customerContact2 ||
                          formData.customerContact2
                        }
                        onChange={handleContactChange}
                        required
                      />
                      {selectedBooking?.customerContact2 ||
                        formData.customerContact2}
                    </label>
                  </div>
                </div>
                <button type="submit">Submit</button>
              </form>
            </Modal>

            <StatusTypeModel
              isOpen={subModalIsOpen}
              onClose={handleSubModalClose}
              statusTypeSub={statusTypeSub}
              handleChange={handleStatusOnChange}
              handleSubmit={handleStatusTypeSubjectSubmit}
              statusType={statusType}
            />

            <div className="TripBookingList">
              {filteredBooking.length < 1 ? (
                <p
                  class="mx-auto"
                  style={{ textAlign: "center", width: "100%" }}
                >
                  There is No Booking Found
                </p>
              ) : (
                filteredBooking.map((items, index) => {
                  console.log('items:',items)
                  return (
                    <>
                      {(Number(items.Balance) !== 0 || new Date(items.Departure_Datetime) >= new Date()) ? (
                        <div className="TripBookingIndex">
                          <div className="TripBookingIndex0">
                            <div className="TripBookingGrp">
                              <p className="TripBookingGrpLables">Id</p>
                              <p className="TripBookingGrpValues">
                                {items.Booking_Id}
                              </p>
                            </div>
                            <div className="TripBookingGrp">
                              <p className="TripBookingGrpLables">Name</p>
                              <p className="TripBookingGrpValues">
                                {items.Customer_Name}
                              </p>
                            </div>
                            <div className="TripBookingGrp">
                              <p className="TripBookingGrpLables">Contact</p>
                              <p className="TripBookingGrpValues">
                                {items.Contact1}
                              </p>
                            </div>
                          </div>
                          <div className="TripBookingIndex1">
                            <p className="TripBookingGrpDT">{items.Bus_Name}</p>
                            <FontAwesomeIcon
                              className="TripBookingBusIcon"
                              style={
                                items.Balance === 0
                                  ? { color: "green", opacity: "0.5" }
                                  : { color: "red", opacity: "0.5" }
                              }
                              icon={faBus}
                            ></FontAwesomeIcon>
                            <p className="TripBookingGrpDT1">
                              {DateTimeConvert(
                                items.Departure_Datetime.toString()
                              )}
                            </p>
                            <div className="TripBookingGrpBtn">
                              <FontAwesomeIcon
                                className="TripBookingEditIcon"
                                onClick={() => handleEdit(items)}
                                title="Edit"
                                icon={faEdit}
                              ></FontAwesomeIcon>
                              <FontAwesomeIcon
                                className="TripBookingDeleteIcon"
                                onClick={() => handleDelete(items)}
                                title="Delete"
                                icon={faTrash}
                              ></FontAwesomeIcon>
                            </div>
                          </div>
                          <div className="TripBookingIndex2">
                            <div className="TripBookingGrp">
                              <p className="TripBookingGrpLables">Fare</p>
                              <p className="TripBookingGrpValues">
                                ₹ {items.Fare}
                              </p>
                            </div>
                            <div className="TripBookingGrp">
                              <p className="TripBookingGrpLables">Paid</p>
                              <p className="TripBookingGrpValues">
                                ₹ {items.Paid}
                              </p>
                            </div>
                            <div className="TripBookingGrp">
                              <p className="TripBookingGrpLables">Balance</p>
                              <p className="TripBookingGrpValues">
                                ₹ {items.Balance}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}{" "}
                    </>
                  );
                })
              )}
            </div>
          </div>
        </div>
      )}
      {isLoading && <SmallLoading />}

      {!isLoading && <Footer></Footer>}
    </>
  );
}

//                          <label className='TripBookingFormLabels'>Last Service Date </label><input style={{height:"35px"}} className="TripBookingFormInputs" type={'text'} placeholder='Date'  readOnly={true} name="lastServiceDate" value={selectedBooking? FormatDate(selectedBooking.lastServiceDate): formData.lastServiceDate ? FormatDate(formData.lastServiceDate):formData.lastServiceDate}></input>
//overlayClassName="TripBookingFormoverlay" className="TripBookingFormModal"
/*

                        <button className='TripBookingformCustomerDetailsSMSBtn' style={{display:"none !important"}} title='Send SMS'>Send <FontAwesomeIcon className='TripbookingMsg' icon={faMessage}></FontAwesomeIcon></button>
<div className='TripBookingList'>
                    <table className='TripBookingTable'>
                    <tr className='TripBookingTableRow'>
                        <th>Id</th>
                        <th>Name</th>
                        <th>Contact</th>
                        <th>Reg No</th>
                        <th>Departure Date</th>
                        <th>Departure Time</th>
                        <th>Paid</th>
                        <th>Balance</th>
                        <th>Driver Salary</th>
                        <th>E</th>
                        <th>D</th>
                    </tr>
                    <tr className='TripBookingTableRow'>
                        <td>Id</td>
                        <td>Name</td>
                        <td>Contact</td>
                        <td>Reg No</td>
                        <td>Departure Date</td>
                        <td>Departure Time</td>
                        <td>Paid</td>
                        <td>Balance</td>
                        <td>Driver Salary</td>
                        <td>E</td>
                        <td>D</td> 
                        </tr>
                    </table>
                </div>


  const url = "https://whatsapponcloud.com/process.env.REACT_APP_API_BASE_URL/send";

  let result = `Upcoming Journey Details🚍

  Dear *${selectedBooking.customerName}*, you have an upcoming journey from *${selectedBooking.pickupLocation}* to *${selectedBooking.dropLocation}* at  ${ selectedBooking ? DateTimeConvert(selectedBooking.departureDateTime):""} with Aathirran Travels.
  
  Boarding Point- ${selectedBooking.pickupLocation}
  Bus No.- ${selectedBooking.busRegNo}
  Driver Contact Details- ${selectedBooking.driverContact1}
  Booking Confirmed.
  Enjoy a safe, on-time, and comfortable journey with us.
  
  Team Aathirran Travels.`;
  
  const bodyData = {
    number: parseInt(formData.customerContact1 ? formData.customerContact1 : selectedBooking.customerContact1, 10), // Convert the number input to an integer
    type: "text",
    message: result,
    instance_id: "66E540B9A438E", // Replace with your actual instance_id
    access_token: "66e53272b4085" // Your access token
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(bodyData),
    });

    const result = await response.json();
    if (response.ok) {
      SuccessMSG("Message sent successfully:", result);
    } else {
      FailedMSG("Failed to send message:", result);
    }
  } catch (error) {
    FailedMSG("Error occurred while sending message:", error);
  }

  */
